<p class="w-12 p-t p-b p-r-3-s p-l-5-s bg-col-53 p2 center"
   *ifNotTradeStore>{{coutdown}}</p>
